<script>
export default {
    name: "Stamp",
    data(){
        return{
            companyUrl:this.$root.companydetails.mainSignatureUrl,
        }
    }
}
</script>
<template>
    <div class="w-full -mt-20" >
        <div class="flex items-center justify-end mr-48 pb-2" ><img :src="companyUrl"></div> 

    </div>
    
</template>


